import React from 'react'

import styles from './EventTable.module.css'

import iconHighTide from '../../assets/images/icon-high-tide.svg'
import iconLowTide  from '../../assets/images/icon-low-tide.svg'
import iconSunrise  from '../../assets/images/icon-sunrise.svg'
import iconSunset   from '../../assets/images/icon-sunset.svg'


const typeMapping = {
  'High': {
    title: 'High tide',
    icon:  iconHighTide,
  },
  'Low': {
    title: 'Low tide',
    icon:  iconLowTide,
  },
  'sunrise': {
    title: 'Sunrise',
    icon:  iconSunrise,
  },
  'sunset': {
    title: 'Sunset',
    icon:  iconSunset,
  },
}


export default ({events}) => {
  const rows = events.map(event => {

    const title  = typeMapping[event.type].title
    const icon   = typeMapping[event.type].icon
    const time   = event.moment.format('h:mm a')
    const height = event.v && event.v.toFixed(1)

    return (
      <div className={title === 'Sunrise' || title === 'Sunset' ? styles.sun : styles.row} key={event.id}>
        <div className={styles.type}>
          <img className={styles.icon} src={icon} />
          <span className={styles.title}>{title}</span>
        </div>
        <div className={styles.info}>
          { height ?
            <span>{height} ft.</span>
            :
            <span>&nbsp;</span>
          }
        </div>
        <div className={styles.time}>
          {time}
        </div>
      </div>
    )
  })

  return (
    <div className={styles.table}>
      {rows}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/DayPage/EventTable.js